import { cloudFunctionsBaseUrl } from "./firebaseEnv";

const LEXI_BASE = "https://us-central1-lexi-ai-peru.cloudfunctions.net";

const resolveUrl = (envKey, fallbackPath) =>
  process.env[envKey] || `${cloudFunctionsBaseUrl}/${fallbackPath}`;

export const FUNCTION_URLS = {
  axisOrquestador: process.env.REACT_APP_AXIS_ORQUESTADOR_URL || `${LEXI_BASE}/axis_Orquestador`,
  hiroAnalizarCvDirecto: resolveUrl("REACT_APP_HIRO_ANALIZAR_CV_URL", "hiro_analizarCVDirecto"),
  hiroProcessFragmentEmbeddings: resolveUrl(
    "REACT_APP_HIRO_PROCESS_FRAGMENT_EMBEDDINGS_URL",
    "hiro_processFragmentEmbeddings"
  ),
  hiroProcessSummaryEmbedding: resolveUrl(
    "REACT_APP_HIRO_PROCESS_SUMMARY_EMBEDDING_URL",
    "hiro_processSummaryEmbedding"
  ),
  axisOrquestadorLegacy: process.env.REACT_APP_AXIS_ORQUESTADOR_LEGACY_URL || `${LEXI_BASE}/axis_Orquestador`,
  echoDistributeAnnouncement: process.env.REACT_APP_ECHO_DISTRIBUTE_ANNOUNCEMENT_URL || `${LEXI_BASE}/echo_distributeAnnouncement`,
  ragProcessEmbeddings: resolveUrl("REACT_APP_RAG_PROCESS_EMBEDDINGS_URL", "rag_processEmbeddings"),
  novaInteraction: resolveUrl("REACT_APP_NOVA_INTERACTION_URL", "nova_interaction"),
  bulkCreateUsersHttp: resolveUrl("REACT_APP_BULK_CREATE_USERS_HTTP_URL", "bulkCreateUsersHttp"),
  vexaSalesAgent: process.env.REACT_APP_VEXA_SALES_URL || `${LEXI_BASE}/vexa_salesAgent`,
  lexiProcessFragmentEmbeddings: process.env.REACT_APP_LEXI_PROCESS_FRAGMENT_EMBEDDINGS_URL || `${LEXI_BASE}/lexi_processFragmentEmbeddings`,
  hiroEvaluarCandidatos:
    process.env.REACT_APP_HIRO_EVALUAR_URL || `${LEXI_BASE}/hiro_evaluarCandidatos`,
  hiroResumirCv:
    process.env.REACT_APP_HIRO_RESUMIR_CV_URL || `${LEXI_BASE}/hiro_resumirCV`,
  hiroProcessSummaryEmbeddingRun:
    process.env.REACT_APP_HIRO_PROCESS_SUMMARY_EMBEDDING_RUN_URL ||
    "https://hiro-processsummaryembedding-pdgfj3iftq-uc.a.run.app",

  vexaCompile: process.env.REACT_APP_VEXA_COMPILE_URL || 'https://vexa-compile-nu3n7mxlzq-uc.a.run.app',
  vexaRecompile: process.env.REACT_APP_VEXA_RECOMPILE_URL || 'https://vexa-recompile-nu3n7mxlzq-uc.a.run.app',
  vexaStatus: process.env.REACT_APP_VEXA_STATUS_URL || `${LEXI_BASE}/vexa_status`,
  vexaDeleteManual: process.env.REACT_APP_VEXA_DELETE_URL || `${LEXI_BASE}/vexa_deleteManual`,
  vexaHealth: process.env.REACT_APP_VEXA_HEALTH_URL || `${LEXI_BASE}/vexa_health`,
  vexaIngestManifest: process.env.REACT_APP_VEXA_INGEST_MANIFEST_URL || `${LEXI_BASE}/vexa_ingestManifest`,
  vexaChatHistory: process.env.REACT_APP_VEXA_CHAT_HISTORY_URL || `${LEXI_BASE}/vexa_chatHistory`,
  vexaFeedback: process.env.REACT_APP_VEXA_FEEDBACK_URL || `${LEXI_BASE}/vexa_feedback`,
};

export default FUNCTION_URLS;
